import React, { useState } from 'react';

import { Row, Col } from 'react-bootstrap';
import { Draggable } from 'react-beautiful-dnd';

import editIcon from 'images/icons/invite/edit.svg';
import ModalForm from '../Form/Modal';

export default function Item({ item, index }) {
  const [showModal, setShowModal] = useState(false);

  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    opacity: isDragging ? 0.5 : 1,
    ...draggableStyle,
  });

  return (
    <>
      <Draggable draggableId={item.id} index={index}>
        {(provided, snapshot) => (
          <li
            className="list-group-item"
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={getItemStyle(
              snapshot.isDragging,
              provided.draggableProps.style,
            )}
          >
            <Row>
              <Col md={10}>
                <i className="fa fa-bars mr10" />
                {item.attributes.title}
              </Col>
              <Col md={2} className="text-right">
                <a onClick={() => setShowModal(true)} className="mr10">
                  <img src={editIcon} />
                </a>
              </Col>
            </Row>
          </li>
        )}
      </Draggable>
      <ModalForm show={showModal} onClose={() => setShowModal(false)} template={item} />
    </>
  );
}
